// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pza_","rootMobile":"styles_rootMobile__bZhZK"};